import { render, staticRenderFns } from "./ConnectionChangeLogsDetailsView.vue?vue&type=template&id=c5085f36&scoped=true"
import script from "./ConnectionChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./ConnectionChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./ConnectionChangeLogsDetailsView.vue?vue&type=style&index=0&id=c5085f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5085f36",
  null
  
)

export default component.exports